// extracted by mini-css-extract-plugin
export var cartContainer = "_ny-4";
export var gray = "_ny-1";
export var itemContainer = "_ny-2";
export var itemDetails = "_ny-3";
export var strong = "_ny-0";